export default "__VITE_ASSET__75c623be__"